import * as React from 'react';
import { ListItem } from '../ListItem';
import { getDescription } from '../../utils/folders';
export function List(_ref) {
  var folders = _ref.folders,
      selectedIds = _ref.selectedIds,
      onChangeFolder = _ref.onChangeFolder;
  return /*#__PURE__*/React.createElement("div", null, folders.map(function (folder) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: folder.id,
      id: folder.id,
      name: folder.name,
      imageUrl: folder.imageUrl,
      description: getDescription(folder.offersCount),
      selected: Boolean(selectedIds[folder.id]),
      onChange: onChangeFolder
    });
  }));
}